import { patchState, signalStore, withComputed, withMethods, withState } from '@ngrx/signals';
import { IAuthState } from 'common_library';

export type AppAuthState = 'starting' | 'logged-in' | 'logged-out';

export interface AppState {
  state: AppAuthState;
  authState: IAuthState | null;
}

export const initialAppState: AppState = {
  state: 'logged-out',
  authState: null,
};

export const AppStore = signalStore(
  { providedIn: 'root' },
  withState(initialAppState),
  withComputed(({ authState, state }) => ({
    isStarting: () => state() === 'starting',
    isLoggedIn: () => state() === 'logged-in',
    isLoggedOut: () => state() === 'logged-out',
    isAuthenticated: () => state() === 'logged-in' && !!authState(),
    user: () => authState()?.user ?? null,
  })),
  withMethods((store) => ({
    setState(state: AppAuthState): void {
      patchState(store, { state });
    },
    setAuthState(authState: IAuthState | null): void {
      patchState(store, {
        state: authState ? 'logged-in' : 'logged-out',
        authState,
      });
    },
    resetAuth(): void {
      patchState(store, { state: 'logged-out', authState: null });
    },
  }))
);
